// src/components/PostSummaryList/PostSummaryList.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './PostSummaryList.scss'
import { useRefs } from '../../context/RefContext'
import { useEffect } from 'react';
import PostSummaryCard from '../PostSummaryCard/PostSummaryCard'; // Will be our refactored BlogElement
import { useLocation } from 'react-router-dom';

const PostSummaryList = ({ posts }) => {
    return (
        <div className='news-section'>
        <div className='post-summary-list-container'> {/* Add a container for styling */}
            {posts.map(post => (
                <PostSummaryCard key={post.slug} post={post} />
            ))}
        </div>
        </div>
    );
};
export default PostSummaryList;
